import { render, staticRenderFns } from "./view_list_total.vue?vue&type=template&id=476da22e&scoped=true"
import script from "./view_list_total.vue?vue&type=script&lang=js"
export * from "./view_list_total.vue?vue&type=script&lang=js"
import style0 from "./view_list_total.vue?vue&type=style&index=0&id=476da22e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476da22e",
  null
  
)

export default component.exports